module.exports = __webpack_public_path__ + "static/media/Face-2-Face-Nike-Art.7e30556f.png";